import { Center, AspectRatio } from '@chakra-ui/react'
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { ItListItemType } from 'types/graphql'

import { itemDescriptionMap } from 'src/components/features/EditItList/EditItListItems/ItListItemTypes'
import Icon from 'src/components/widgets/Icon/Icon'
import ItListImage from 'src/components/widgets/ItListImage/ItListImage'

const Image: React.FC<{
  coverUrl?: string
  type: ItListItemType
}> = ({ coverUrl, type }) => {
  const Placeholder = itemDescriptionMap[type].Placeholder
  return coverUrl ? (
    <AspectRatio ratio={1 / 1}>
      <ItListImage
        htmlHeight={100}
        htmlWidth={100}
        alt={`${type} thumbnail`}
        borderRadius={12}
        objectFit="cover"
        src={coverUrl}
        data-testid="itemCard-itemImage"
      />
    </AspectRatio>
  ) : Placeholder ? (
    <>
      <AspectRatio ratio={1 / 1}>
        <Placeholder />
      </AspectRatio>
      {!coverUrl && (
        <Center
          position="absolute"
          borderRadius="full"
          boxShadow="xl"
          w="24px"
          h="24px"
          style={{ border: '10px solid white' }}
          top={2}
          left={2}
        >
          <Icon color="danger" fontSize="16px" icon={faCircleExclamation} />
        </Center>
      )}
    </>
  ) : null
}

export default Image
